// src/config/sidebarLinks.js
import { BookOpen, Briefcase, Group, Mic, Sparkles } from 'lucide-react';

export const userNavLinks = [
  { label: 'Create', icon: <Sparkles size={20} />, to: '/conversation-type' },
  { label: 'My Practice Conversations', icon: <Mic size={20} />, to: '/practice-history' },
  { label: 'My Training Sessions', icon: <BookOpen size={20} />, to: '/training-sessions' },
];

export const orgNavLinks = [
  { label: 'Groups', icon: <Group size={20} />, to: '/org/:orgId/management?tab=groups'},
  { label: 'Organization', icon: <Briefcase size={20} />, to: '/org/:orgId/management?tab=organization' },

];
